import React from "react";
import clsx from "clsx";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <p className={styles.text}>以下を順にご確認ください。</p>
    </div>
    <ul className={clsx(styles.list, styles.number)}>
      <li className={styles.item}>
        メールが迷惑メールフォルダに届いていないか確認する。
      </li>
      <li className={styles.item}>
        「@enageed.jp」からのメールの受信を許可する。
      </li>
    </ul>
    <p className={styles.heading}>【上記の手順で解決しなかった場合】</p>
    <div>
      <p className={styles.heading}>▶ エナジード窓口を担当されている先生</p>
      <p className={styles.text}>
        サポート担当に連絡し、メールの再送またはメールアドレスの再登録を依頼してください。※確認後、招待メールを再送します。
      </p>
    </div>
    <div>
      <p className={styles.heading}>▶ その他の先生</p>
      <p className={styles.text}>
        学校管理者の権限をお持ちの先生にメールの再送を依頼し、メールアドレスが正しく登録されているかをご確認ください。
      </p>
    </div>
  </div>
);

export const INITIAL_LOGIN_INVITATION_EMAIL_FAQ: FaqCategoryItem = {
  id: "initial-login-invitation-email-faq",
  question: "初回ログインのための招待メールが届かない",
  Answer,
};
